import {
	GeometryTypes,
	PathOperationTypes,
	ShapeType,
} from "../widgets/interfaces/model/enumerations/index";
import { IPresetGeometry } from "../widgets/interfaces/model/geometry/PresetGeometry";

/**
 * Line preset definition
 * ECMA-376, Third Edition, Part 1 - Fundamentals And Markup Language Reference
 * /OfficeOpenXML-DrawingMLGeometries/presetShapeDefinitions.xml
 */
export const line: IPresetGeometry = {
	pathLst: [{
		operations: [
			{ pt: { x: "l", y: "t" }, type: PathOperationTypes.MOVE_TO },
			{ pt: { x: "r", y: "b" }, type: PathOperationTypes.LINE_TO },
		],
	}],
	presetShape: ShapeType.rect,
	rect: { l: "l", t: "t", r: "r", b: "b" },
	type: GeometryTypes.PRESET,
};

/**
 * Microsoft open xml preset definition (for Reference purpose only)
 * <line>
 *   <cxnLst xmlns="http://schemas.openxmlformats.org/drawingml/2006/main">
 *     <cxn ang="cd4">
 *       <pos x="l" y="t" />
 *     </cxn>
 *     <cxn ang="3cd4">
 *       <pos x="r" y="b" />
 *     </cxn>
 *   </cxnLst>
 *   <pathLst xmlns="http://schemas.openxmlformats.org/drawingml/2006/main">
 *    <path>
 *       <moveTo>
 *         <pt x="l" y="t" />
 *       </moveTo>
 *       <lnTo>
 *         <pt x="r" y="b" />
 *       </lnTo>
 *     </path>
 *   </pathLst>
 * </line>
 */
